/**
 * Utilitaire de logging sécurisé qui respecte l'environnement d'exécution
 */

class Logger {
  static instance;
  isProduction;

  constructor() {
    // Vérifie si nous sommes en production en se basant sur les variables d'environnement et l'URL
    this.isProduction = process.env.NODE_ENV === 'production' || 
                       process.env.NODE_ENV === 'mainnet' || 
                       window.location.hostname.includes('softmarket.io');
    
    // Force la désactivation des logs en production
    if (this.isProduction) {
      console.log = () => {};
      console.info = () => {};
      console.warn = () => {};
      console.error = () => {};
      console.debug = () => {};
    }
  }

  static getInstance() {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  formatLog(level, message, data) {
    return {
      timestamp: new Date().toISOString(),
      level,
      message,
      data,
    };
  }

  writeLog(logEntry) {
    // Ne pas logger en production
    if (this.isProduction) return;

    const logString = `[${logEntry.timestamp}] ${logEntry.level.toUpperCase()}: ${logEntry.message}`;
    
    switch (logEntry.level) {
      case 'error':
        console.error(logString, logEntry.data || '');
        break;
      case 'warn':
        console.warn(logString, logEntry.data || '');
        break;
      case 'info':
        console.info(logString, logEntry.data || '');
        break;
      case 'debug':
        break;
      default:
    }
  }

  info(message, data) {
    this.writeLog(this.formatLog('info', message, data));
  }

  warn(message, data) {
    this.writeLog(this.formatLog('warn', message, data));
  }

  error(message, error) {
    this.writeLog(this.formatLog('error', message, {
      error: error instanceof Error ? {
        message: error.message,
        stack: error.stack,
        name: error.name
      } : error
    }));
  }

  debug(message, data) {
    if (!this.isProduction) {
      this.writeLog(this.formatLog('debug', message, data));
    }
  }

  // Méthode pour vérifier si les logs sont activés
  isLoggingEnabled() {
    return !this.isProduction;
  }
}

// Exporter une instance unique du logger
export const logger = Logger.getInstance();
